const GET_PRICES_FOR_ONE_NFT = 'GET_PRICES_FOR_ONE_NFT' as const;
const GET_USDT_PRICE = 'GET_USDT_PRICE' as const;

export default {
  GET_PRICES_FOR_ONE_NFT,
  GET_USDT_PRICE,
};
